import Utils from "./Utils";
import Alert from "../components/Alert";
import Player from "../components/Player";
import Memes from "../components/Memes";
import Popups from "../components/Popups";
import Modals from "../components/Modals";

(function ($) {
    window['__onGCastApiAvailable'] = function(isAvailable) {
        if (isAvailable) {
            for(var index in Player.players) {
                Player.players[index].setupChromeCast();
            }
        }
    };
    $(".topper").on('click', function() {
        $('html,body').animate({scrollTop:0},480, 'swing');
    });
    $(".comments_go_top").on('click', function(evt) {
        evt.preventDefault();
        $("html, body").animate({'scrollTop': ($("#content_comments_section").offset().top - $("header.sticky").height() - 10)});
    });
    $(".comments_go_bottom").on('click', function(evt) {
        evt.preventDefault();
        var base_offset = $("#content_comments__base").offset().top;
        var base_height = $("#content_comments__base").height();
        $("html, body").animate({'scrollTop': (Math.max(base_offset, (base_offset + base_height - 150)) - $("header.sticky").height() - 10)});
    })
    $(".toggle-sidemenu").click(function() {
        $(this).toggleClass("open");
        $(".siteshift").toggleClass("active");
        $(".sidemenu").toggleClass("active");
        $(".shield").toggleClass("active");
        $('.mobile-dock-nav').toggleClass('hidden');
        $(document.body).addClass('modal-open');
        Popups.closePopup();
    });
    $(".shield").click(function() {
        $(".siteshift").removeClass("active");
        $(".sidemenu").removeClass("active");
        $(".shield").removeClass("active");
        $(".toggle-sidemenu").removeClass("open");
        $('.mobile-dock-nav').toggleClass('hidden');
        $(document.body).removeClass('modal-open');
    });
    $('[data-comments-sorting]').on('click', function () {
        if($(this).hasClass('active')) {
            return false;
        }
        var $btn = $(this);
        var $mediaId = $btn.attr('data-media-id');
        var $title = $btn.attr('data-title');
        var $commentsSorting = $btn.attr('data-comments-sorting');
        var ajaxHash = $btn.attr('data-ajax-hash');
        $('[data-comments-sorting].active').removeClass('active');
        $btn.addClass('active');

        Utils.setCookie('_cs', $commentsSorting, 365*60);
        Utils.commit_ajax_action('fetch_comments', {
            'media_id': $mediaId,
            'sorting': $commentsSorting,
            'hash': ajaxHash
        }, function(response) {
            if(response && response.status && response.status === 'error') {
                if(response.message) {
                    Alert.showGeneralAlert(response.message);
                } else {
                    Alert.showGeneralAlert("Error fetching comments, try refreshing the page");
                }
                return false;
            }
            if($commentsSorting === 'votes_down') {
                $title = $title + '<i class="icon-custom poop-brown"></i>';
            }
            $('.comments-toggle').html($title);
            $('#content_comments__base').remove();
            $('.comment-form').after($(response.cargo.html));
        }, function() {
            Alert.showGeneralAlert("Something went wrong, try refreshing the page");
        });
    });
    $('[data-series-sorting]').on('click', function () {
        var sorting = $(this).attr('data-series-sorting')
        var $wrapper = $('.row.tiles.categories');
        if($(this).hasClass('active')) {
            return false;
        }
        $('[data-series-sorting].active').removeClass('active');
        $(this).addClass('active');
        Utils.setCookie('_ss', sorting, 365*60);

        if(sorting === 'alpha') {
            $('.series-sorting-wrapper .dropdown-toggle').text($(this).attr('data-title'));
            $wrapper.find('.tile').sort(function (a, b) {
                return $(a).data('collection-title').localeCompare($(b).data('collection-title'));
            }).appendTo($wrapper);
        } else {
            $('.series-sorting-wrapper .dropdown-toggle').text($(this).attr('data-title'));
            $wrapper.find('.tile').sort(function (a, b) {
                return parseInt($(b).data('collection-views')) - parseInt($(a).data('collection-views'));
            }).appendTo($wrapper);
        }
    });
    $('[data-stories-sorting]').on('click', function () {
        var sorting = $(this).attr('data-stories-sorting');
        if($(this).hasClass('active')) {
            return false;
        }
        Utils.setCookie('_sts', sorting, 365*60); //_stories_sorting
        window.location.href = $(this).attr('href');
    });
    $('[data-toggle-search]').on('click', function() {
        var $searchForm = $('.mobile-search-wrapper');
        $(this).toggleClass('active');
        $searchForm.toggleClass('open');
    });
    $('.mobile-dock-nav a').on('click', function (evt) {
        evt.preventDefault();
        var $link = $(this);
        if($link.hasClass('active')) {
            return false;
        }
        Utils.animateDockIcons($(this), function () {
            if(!$link.hasClass('login-link')) {
                window.location.href = $link.attr('href');
            }
        });
    });
    $('.dock-nav-popup').on('click', 'a', function (evt) {
        evt.preventDefault();
        var $link = $(this);
        var $popupId = $link.parents('.cs-popup').attr('data-popup-id');
        var $relatedNavLink = $('[data-popup-toggle="'+$popupId+'"]');
        Utils.animateDockIcons($relatedNavLink, function () {
            window.location.href = $link.attr('href');
        });
    });
    $('[data-scroll-to]').on('click', function (evt) {
        evt.preventDefault();
        var $target = $($(this).attr('data-scroll-to'));
        $('html,body').animate({scrollTop: ($target.offset().top - 100)},250, 'swing');
    });
    $('[data-toggle="description-show-more"]').on('click', function () {
        var $btn = $(this);
        if($btn.hasClass('open')) {
            $btn.removeClass('open');
            $btn.text($btn.attr('data-closed-text'));
            $btn.parents('.row.desc').find('.desc-full').hide();
            $btn.parents('.row.desc').find('.desc-small').show();
        } else {
            $btn.addClass('open');
            $btn.text($btn.attr('data-open-text'));
            $btn.parents('.row.desc').find('.desc-full').show();
            $btn.parents('.row.desc').find('.desc-small').hide();
        }
    });
    $('.sidebar-login-link').on('click', function (evt) {
        evt.preventDefault();
        $(".shield").click();
        Utils.animateDockIcons($('.mobile-dock-nav .login-link'), function () {
            Modals.showModalTemplate('login-modal', function ($modal) {
                $modal.on('click', '[data-close-modal]', function () {
                    Utils.animateDockIcons($('.mobile-dock-nav').find('.was-active'));
                });
            });
        });
    });
    $('.sidebar-dock-toggle').on('click', function (evt) {
        evt.preventDefault();
        if($(this).hasClass('active')) {
            $(document.body).removeClass('hidden-dock').addClass('visible-dock');
            Utils.removeCookie('_hmd');
        } else {
            $(document.body).removeClass('visible-dock').addClass('hidden-dock');
            Utils.setCookie('_hmd', '1', 365*24);
        }
    });
    $('[data-target-tab]').on('click', function () {
        var $wrapper = $(this).parents('.cs-tabs');
        var $targetId = $(this).attr('data-target-tab');
        var $targetTab = $wrapper.find('[data-tab-id="'+$targetId+'"]');
        var $currentTab = $wrapper.find('[data-tab-id].open');
        var $tabsInner = $wrapper.find('.cs-tabs-inner');

        //change active tab button
        $(this).parent().find('[data-target-tab]').removeClass('active');
        $(this).addClass('active');

        //force the height of the bigger tab on the parent to ease the transition
        if($currentTab.height() >= $targetTab.height()) {
            $tabsInner.animate({'height' : $currentTab.height()}, 300, function () {
                $('[data-tab-id]').hide();
                $targetTab.fadeIn(300, function () {
                    $tabsInner.animate({'height' : $targetTab.height()}, 300);
                });
            });
        } else {
            $tabsInner.animate({'height' : $targetTab.height()}, 300, function () {
                $('[data-tab-id]').hide();
                $targetTab.fadeIn(300, function () {
                    $tabsInner.animate({'height' : $targetTab.height()}, 300);
                });
            });
        }
    });
    $(document.body).on('click', '[data-slide-toggle]', function () {
        var $target = $($(this).attr('data-slide-toggle'));
        $(this).toggleClass('active');
        $target.slideToggle();
        if($(this).hasClass('active') && $(this).attr('data-open-text') !== '') {
            $(this).text($(this).attr('data-open-text'));
        }
        if(!$(this).hasClass('active') && $(this).attr('data-closed-text') !== '') {
            $(this).text($(this).attr('data-closed-text'));
        }
    });
    $(document.body).on('click', '[data-toggle-container]', function (evt) {
        evt.preventDefault();
        var $target = $($(this).attr('data-toggle-container'));
        var $icon = $(this).find('.icon')
        if($target.is(':visible')) {
            $target.hide();
            $icon.removeClass($icon.attr('data-active-class')).addClass($icon.attr('data-inactive-class'));
        } else {
            $target.show();
            $icon.removeClass($icon.attr('data-inactive-class')).addClass($icon.attr('data-active-class'));
        }
    });
    $(document.body).on('click', '[data-tags-toggle]', function (evt) {
        evt.preventDefault();
        $(this).hide();
        $($(this).attr('data-tags-toggle')).show();
    });
    $(document.body).on('click', ".track_click", function(e) {
        var href = $(this).attr('href') || false,
            event_category, event_action, event_label, domain;
        if(!href) {
            return false;
        }
        event_category = $(this).attr("data-event-category") || "outbound";
        event_action = $(this).attr("data-event-action") || "click";
        event_label = "Internal";
        domain = Utils.extractDomain(href, "crazyshit.com");
        if("crazyshit.com" !== domain) {
            event_label = domain;
        }
        event_label = $(this).attr("data-event-label") || event_label;
        if(typeof ga == "function") {
            ga('send', 'event', event_category, event_action, event_label, {
                'transport':	"beacon"
            });
        }
    });
    $(document.body).on('click', '.dropdown-toggle', function (evt) {
        evt.stopPropagation();
        var $menu = $(this).parents('.dropdown-wrapper').find('.dropdown-menu');
        $(this).toggleClass('active');
        $menu.toggleClass('show');
        if($menu.offset().top + $menu.height() > $(document.body).height()) {
            $menu.css('top', -($menu.height() + $(this).height() + 10));
        } else {
            $menu.css('top', '115%');
        }
    });
    $(document.body).on('click', function () {
        var $openDropDown = $('.dropdown-toggle.active');
        if($openDropDown.length > 0) {
            $openDropDown.click();
        }
        var $openPopup = $('.cs-popup.open');
        if($openPopup.length > 0) {
            Popups.closePopup();
        }
    });
    $(document).ready(function() {
        var iframe_fallback_attempts = 0;
        var iframe_fallback_max_attempts = 10;
        var iframe_fallback_interval = window.setInterval(function() {
            if((iframe_fallback_max_attempts && (iframe_fallback_attempts >= iframe_fallback_max_attempts)) || !$("iframe[data-fallback]").length) {
                window.clearInterval(iframe_fallback_interval);
                iframe_fallback_interval = null;
                return;
            }
            $("iframe[data-fallback]").each(function() {
                if($(this).is(":hidden") || ($(this).height() < 10)) {
                    var orig_el = $(this);
                    var parent_el = $(this).parent();
                    var remove_parent = $(parent_el).hasClass('removable');
                    var fallback_url = $(this).attr('data-fallback');
                    var html = [];
                    html.push("<iframe src=\""+ esc_attr(fallback_url) +"\"");
                    $.each(this.attributes, function() {
                        if(this.specified && (-1 == $.inArray(this.name, ["style", "data-fallback", "data-has-parent"]))) {
                            html.push(" "+ this.name +"=\""+ esc_attr(this.value) +"\"");
                        }
                    });
                    html.push("></iframe>");
                    if(remove_parent) {
                        $(parent_el).after( html.join("") );
                        $(parent_el).empty().remove();
                    } else {
                        $(this).after( html.join("") );
                        $(this).empty().remove();
                    }
                }
            });
            iframe_fallback_attempts++;
        }, 1000);
        Utils.initSelect2();
        Utils.setupFooter();
        Utils.initClipboard();
        Utils.setupAutoExpandFields();
        if($('#crazyshit_video').length > 0){
            Player.getPlayer('crazyshit_video');
        }
        $(window).on('resize', function () {
            Utils.setupFooter();
            var $trendingStories = $('.trending.stories');
            if($trendingStories.length > 0) {
                if($(window).width() < 1300 && $(window).width() > 960) {
                    $trendingStories.find('[data-slides-count]').attr('data-slides-count', 3);
                } else {
                    $trendingStories.find('[data-slides-count]').attr('data-slides-count', 2);
                }
            }
        });

        var scrollPos = $(window).scrollTop();
        var lastDate = new Date().getTime();
        $(window).on('scroll', function (evt) {
            var currPos = $(window).scrollTop();
            var delay = evt.timeStamp - lastDate;
            var offset = currPos - scrollPos;
            var scrollSpeed = Math.abs(offset / delay);
            var direction = (offset > 0)? 'down':'up';
            lastDate = evt.timeStamp;
            scrollPos = currPos;

            if(scrollPos > 1 ){
                $(".header").addClass('sticky');
            } else{
                $(".header").removeClass('sticky');
            }
            if($('.memes-wrapper').length > 0) {
                Memes.handleScrollMemeVideos();
            }
            Memes.handleMemesFetch();
            Memes.handleSubMenu(scrollPos, scrollSpeed, direction);
        });
    });
})(jQuery)